module.exports = "/packs/images/eye-closed.svg";